module.exports = __webpack_public_path__ + "img/pic_user_male.febee122.png";